/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'./../InteractionFactory',
	'./../MoveWidgets',
	'./../MoveGroupContent',
	'./../Resize',
	'./../ExpandAction',
	'./../AlignAction'
], function(Class, InteractionFactory, Move, MoveGroupContent, Resize, Expand, Align) {

	const Authoring = Class.extend({

		init: function(logger) {
			Authoring.inherited('init', this, arguments);
			this.logger = logger;
		},

		destroy: function () {
			if (this._handlers) {
				this._handlers.forEach((handler) => {
					handler.remove && handler.remove();
				});
			}
			this._handlers = null;

			if (this._interactions) {
				for (let name in this._interactions) {
					if (this._interactions.hasOwnProperty(name)) {
						const interaction = this._interactions[name].wrapped;
						if (interaction && interaction.destroy) {
							interaction.destroy();
						}
					}
				}
				this._interactions = null;
			}
		},

		getInteraction: function(name){
			const interaction = this._interactions[name];
			return interaction && interaction.wrapped;
		},

		attachInteractions: function(controller) {
			return this._getInteractions(controller, this.logger)
				.then((interactions) => {
					this._interactions = interactions;
					this._attachInteractions(controller, interactions);
				});
		},

		// Private

		_attachInteractions: function(controller, interactions) {
			// TODO: logical grouping of these? maybe per interaction to ease the conditional wrapping?
			// thoughts?
			const {
				resize,
				expand,
				move,
				moveGroupContent,
				align
			} = interactions;

			const focusModeDisabled = controller.config && controller.config.focusModeDisabled;

			// Attach common interaction to shapes, images and widgets
			resize && controller.addActionForSelector(resize, '.page .widget:not(.placeholderWidget)');
			expand && !focusModeDisabled && controller.addActionForSelector(expand, '.page .widget:not(.placeholderWidget)');
			move && controller.addActionForSelector(move, '.page .widget:not(.pagegroup *):not(.placeholderWidget)');
			align && controller.addActionForSelector(align, '.page .widget:not(.placeholderWidget)');

			//groups are selected when sub content is selected and not by clicking on the group node
			resize && controller.addActionForSelector(resize, '.page .pagegroup', true);
			move && controller.addActionForSelector(move, '.page .pagegroup', true);
			align && controller.addActionForSelector(align, '.page .pagegroup', true);
			moveGroupContent && controller.addActionForSelector(moveGroupContent, '.pagegroup .widget');

			this._handleJointInteractions(controller, interactions);
		},

		_handleJointInteractions(controller, interactions) {
			const {
				resize: { wrapped: resize } = {},
				move: { wrapped: move } = {},
				moveGroupContent: { wrapped: moveGroupContent } = {}
			} = interactions;

			this._handlers = [];
			move && this._handlers.push(move.on('move:end', controller.finishMoveSelection, controller));

			// Hide the toolbar when move or resize
			resize && this._handlers.push(resize.on('resize:start', controller.onSelectionMoveOrResize, controller));
			move && this._handlers.push(move.on('move:start', controller.onSelectionMoveOrResize, controller));
			moveGroupContent && this._handlers.push(moveGroupContent.on('move:start', controller.onSelectionMoveOrResize, controller));
		},

		_getInteractions: function(controller, logger) {
			const interactions = {
				resize: Resize,
				expand: Expand,
				move: Move,
				moveGroupContent: MoveGroupContent,
				align: Align
			};

			const factory = new InteractionFactory(controller, logger);

			return factory.getInteractions(interactions);
		}

	});

	return Authoring;
});
